import { graphql } from "gatsby";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import ContentReferenceCard from "../../molecules/Cards/ContentReference";
import "./ParagraphCarouselSlider.scss";

const HandlePrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`arrow ${className}`}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === "Space") {
          onClick();
        }
      }}
    >
      <img src="/prev-arrow.svg" alt="Prev" width={42} height={13} />
    </div>
  );
};

const HandleNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`arrow ${className} me-2`}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === "Space") {
          onClick();
        }
      }}
    >
      <img
        loading="lazy"
        src="/next-arrow.svg"
        alt="Next"
        width={42}
        height={13}
      />
    </div>
  );
};

export const ParagraphCarouselSlider = ({ node, data, theme, path, id }) => {
  var settings = {
    infinite: false, // Infinitely wrap around contents
    speed: 500, // Animation speed in milliseconds
    slidesToShow: 4.3, // How many slides to show in one frame
    slidesToScroll: 1, // How many slides to scroll at once
    arrows: true,
    prevArrow: <HandlePrevArrow />, // Customize Left arrow
    nextArrow: <HandleNextArrow />, // Customize Right arrow
    touchMove: false, // If need swipe slider with fingers By Default it's True
    responsive: [
      // Customize based on breakpoints
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false,
          touchMove: true,
        },
      },
    ],
  };

  const [result, setResult] = useState([]);
  useEffect(() => {
    const newTheme = theme?.map((item) => item?.id);
    const allContentTypes = Object?.values(
      data?.localSearchContentTypes?.store || {}
    )
      ?.filter((item1) => {
        return (
          item1?.field_theme?.some((item2) => newTheme?.includes(item2?.id)) &&
          item1?.id !== id
        );
      })
      ?.sort(
        (a, b) => new Date(b?.field_published) - new Date(a?.field_published)
      );

    setResult(allContentTypes);
  }, [theme, data?.localSearchContentTypes?.store, id]);

  return (
    <>
      <Container className="general-container mb-5 p-0 carousel">
        <>
          {node?.field_component_title && (
            <h2 className="carousel-title">{node?.field_component_title}</h2>
          )}

          {node?.relationships?.field_carousel_item?.length > 0 && (
            <Slider {...settings} className="carousel-slide">
              {node?.relationships?.field_carousel_item?.map((item, key) => {
                return (
                  <div className="custom-slider" key={key}>
                    <ContentReferenceCard
                      title={item?.field_heading}
                      linkTo={item?.field_link?.url}
                      imageURL={
                        item?.relationships?.field_card_image?.relationships
                          ?.field_media_image?.gatsbyImage
                      }
                      eyebrowText={item?.relationships?.field_product_tag?.name}
                      introText={item?.field_summary}
                    />
                  </div>
                );
              })}
            </Slider>
          )}
        </>
        {result?.length > 0 && (
          <>
            <h2 className="carousel-title">
              {path?.split("/")?.includes("partner-spotlight")
                ? "Related material"
                : "Related articles"}
            </h2>
            <Slider {...settings}>
              {result?.map((item, key) => {
                return (
                  <div className="custom-slider" key={key}>
                    <ContentReferenceCard
                      title={item?.title}
                      imageURL={item?.field_image?.gatsbyImage}
                      eyebrowText={item?.field_product_tags?.name || item?.type}
                      authorDetails={item?.field_authors}
                      fieldPublished={item?.field_published}
                      fieldEventPlace={item?.field_event_place}
                      fieldTimeFrame={item?.field_time_frame}
                      field_theme={item?.field_theme}
                      field_region={item?.field_region}
                      field_country={item?.field_country}
                      linkTo={item?.slug?.alias || item?.slug}
                      fieldSubtitle={item?.field_subtitle?.value}
                      body={item?.body}
                    />
                  </div>
                );
              })}
            </Slider>
          </>
        )}
      </Container>
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphCarouselSlider on paragraph__carousel_slider {
    field_component_title
    relationships {
      field_carousel_item {
        field_heading
        field_summary {
          value
        }
        relationships {
          field_card_image {
            relationships {
              field_media_image {
                gatsbyImage(
                  width: 3000
                  fit: CONTAIN
                  layout: FULL_WIDTH
                  quality: 100
                  placeholder: BLURRED
                )
              }
            }
          }
          field_product_tag {
            name
          }
        }
        field_link {
          url
        }
      }
    }
  }
`;
